/**
 * This is required to edit a group as the students may have pending tasks...
 * @type {{0: string, 1: string}}
 */
export const UPDATE_COURSE_TYPES = {
    0: 'CancelTask',
    1: 'CarryOver'
};

// These values are to persist query params throughout the life of the application
export const CONSERVE_PARAMS = [
    'username', 'password', 'userToken', 'env', 'productId', 'authToken'
];

// All groups/Show all in the groups section has a GroupId of 0
export const ALL_GROUP_ID = 0;
export const DEFAULT_GROUP_ID = 1;

export const CONFIG_VARS = {
    classNameMaxLength: 200,
    groupNameMaxLength: 200, // TODO: find the exact limitation (ask back-end). BA 2020-01-06
    passwordMaxLength: 25
};

// ERROR CODES
export const ERROR_CODES = {
    UnexpectedResponseContent: 'UnexpectedResponseContent'
};

export const MAX_GROUP_LENGTH = 12;

// Variables to decide which is the new group and the default group
export const DEFAULT_GROUP_MODAL_ID = -2;
export const NEW_GROUP_MODAL_ID = -1;
export const MAX_GROUP_NAME_DISPLAY = 36;
export const ADMIN_COURSE_AUTHOR = 'Mathletics';

// ProductIds
export const PRODUCT_IDS = {
    Mathletics: 1,
    Spellodrome: 3,
    Phonics: 8,
    Mathletica: 9,
    Readiwriter: 10
};
export const DEFAULT_PRODUCT_ID = 1;

// Key Codes/Name
export const ESCAPE_KEY_CODE = 27;
export const ESCAPE_KEY_NAME = 'Escape';

// Action Type for students
export const actionTypeIds = {
    copy: 1,
    move: 2,
    remove: 3
};

// Default Id for 'Select Class' dropdown
export const INVALID_CLASSNAME = '-1';

export const DEFAULT_UPF_COURSE_ID = 0;



// WEBPACK FOOTER //
// ./helpers/enums.js